
import { Union, Record } from "../fable_modules/fable-library-js.5.3.0/Types.js";
import { unit_type, lambda_type, union_type, list_type, bool_type, record_type, option_type, decimal_type, int32_type, string_type, class_type } from "../fable_modules/fable-library-js.5.3.0/Reflection.js";
import { CharityInfo_$reflection } from "./Challenge.js";
import { TimeOfDay_$reflection } from "./BaseTypes.js";
import { HideCoverImageRequest_$reflection, SetCoverImageRequest_$reflection, ChallengeCoverImage_$reflection } from "./CoverImage.js";
import { LoggedDay_$reflection } from "./DailyLogEditWindow.js";
import { fromParts } from "../fable_modules/fable-library-js.5.3.0/Decimal.js";
import { ApiError_$reflection } from "./ValidationErrors.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.5.3.0/Result.js";
import { SuspendAccountRequest_$reflection, RestoreDailyLogRequest_$reflection, HideDailyLogRequest_$reflection, HideChallengeRequest_$reflection, ModerationStatusResponse_$reflection } from "./Moderation.js";

export class CreateChallengeRequest extends Record {
    constructor(Id, Theme, Unit, Duration, TargetAmount, Charity, Title, Description, StartDate, Timezone, ReminderTimeOfDay, CoverImageKey) {
        super();
        this.Id = Id;
        this.Theme = Theme;
        this.Unit = Unit;
        this.Duration = (Duration | 0);
        this.TargetAmount = TargetAmount;
        this.Charity = Charity;
        this.Title = Title;
        this.Description = Description;
        this.StartDate = StartDate;
        this.Timezone = Timezone;
        this.ReminderTimeOfDay = ReminderTimeOfDay;
        this.CoverImageKey = CoverImageKey;
    }
}

export function CreateChallengeRequest_$reflection() {
    return record_type("Shared.CreateChallengeRequest", [], CreateChallengeRequest, () => [["Id", class_type("System.Guid")], ["Theme", string_type], ["Unit", string_type], ["Duration", int32_type], ["TargetAmount", decimal_type], ["Charity", CharityInfo_$reflection()], ["Title", string_type], ["Description", option_type(string_type)], ["StartDate", class_type("System.DateTime")], ["Timezone", string_type], ["ReminderTimeOfDay", option_type(TimeOfDay_$reflection())], ["CoverImageKey", option_type(string_type)]]);
}

export class ChallengeResponse extends Record {
    constructor(Id, UserId, Theme, Unit, Duration, TargetAmount, Charity, Title, Description, Status, FeePaid, FeeAmountCents, TotalUnitsCompleted, CreatedAt, StartDate, Timezone, PledgeCount, TotalPledged, TotalRaised, ReminderTimeOfDay, HostFirstName, MinAllowedGoal, CoverImage) {
        super();
        this.Id = Id;
        this.UserId = UserId;
        this.Theme = Theme;
        this.Unit = Unit;
        this.Duration = (Duration | 0);
        this.TargetAmount = TargetAmount;
        this.Charity = Charity;
        this.Title = Title;
        this.Description = Description;
        this.Status = Status;
        this.FeePaid = FeePaid;
        this.FeeAmountCents = (FeeAmountCents | 0);
        this.TotalUnitsCompleted = TotalUnitsCompleted;
        this.CreatedAt = CreatedAt;
        this.StartDate = StartDate;
        this.Timezone = Timezone;
        this.PledgeCount = (PledgeCount | 0);
        this.TotalPledged = TotalPledged;
        this.TotalRaised = TotalRaised;
        this.ReminderTimeOfDay = ReminderTimeOfDay;
        this.HostFirstName = HostFirstName;
        this.MinAllowedGoal = MinAllowedGoal;
        this.CoverImage = CoverImage;
    }
}

export function ChallengeResponse_$reflection() {
    return record_type("Shared.ChallengeResponse", [], ChallengeResponse, () => [["Id", class_type("System.Guid")], ["UserId", class_type("System.Guid")], ["Theme", string_type], ["Unit", string_type], ["Duration", int32_type], ["TargetAmount", decimal_type], ["Charity", CharityInfo_$reflection()], ["Title", string_type], ["Description", option_type(string_type)], ["Status", string_type], ["FeePaid", bool_type], ["FeeAmountCents", int32_type], ["TotalUnitsCompleted", decimal_type], ["CreatedAt", class_type("System.DateTimeOffset")], ["StartDate", class_type("System.DateTimeOffset")], ["Timezone", string_type], ["PledgeCount", int32_type], ["TotalPledged", decimal_type], ["TotalRaised", decimal_type], ["ReminderTimeOfDay", option_type(TimeOfDay_$reflection())], ["HostFirstName", option_type(string_type)], ["MinAllowedGoal", option_type(decimal_type)], ["CoverImage", option_type(ChallengeCoverImage_$reflection())]]);
}

export class AddDailyLogRequest extends Record {
    constructor(ChallengeId, Date$, UnitsCompleted, Title, Note, PhotoUrl) {
        super();
        this.ChallengeId = ChallengeId;
        this.Date = Date$;
        this.UnitsCompleted = UnitsCompleted;
        this.Title = Title;
        this.Note = Note;
        this.PhotoUrl = PhotoUrl;
    }
}

export function AddDailyLogRequest_$reflection() {
    return record_type("Shared.AddDailyLogRequest", [], AddDailyLogRequest, () => [["ChallengeId", class_type("System.Guid")], ["Date", class_type("System.DateOnly")], ["UnitsCompleted", decimal_type], ["Title", string_type], ["Note", option_type(string_type)], ["PhotoUrl", option_type(string_type)]]);
}

export class DailyLogResponse extends Record {
    constructor(Date$, UnitsCompleted, Title, Note, PhotoUrl) {
        super();
        this.Date = Date$;
        this.UnitsCompleted = UnitsCompleted;
        this.Title = Title;
        this.Note = Note;
        this.PhotoUrl = PhotoUrl;
    }
}

export function DailyLogResponse_$reflection() {
    return record_type("Shared.DailyLogResponse", [], DailyLogResponse, () => [["Date", class_type("System.DateOnly")], ["UnitsCompleted", decimal_type], ["Title", string_type], ["Note", option_type(string_type)], ["PhotoUrl", option_type(string_type)]]);
}

export class GetDailyLogsRequest extends Record {
    constructor(ChallengeId, Limit, Offset) {
        super();
        this.ChallengeId = ChallengeId;
        this.Limit = (Limit | 0);
        this.Offset = (Offset | 0);
    }
}

export function GetDailyLogsRequest_$reflection() {
    return record_type("Shared.GetDailyLogsRequest", [], GetDailyLogsRequest, () => [["ChallengeId", class_type("System.Guid")], ["Limit", int32_type], ["Offset", int32_type]]);
}

export class GetDailyLogsResponse extends Record {
    constructor(Logs, HasMore) {
        super();
        this.Logs = Logs;
        this.HasMore = HasMore;
    }
}

export function GetDailyLogsResponse_$reflection() {
    return record_type("Shared.GetDailyLogsResponse", [], GetDailyLogsResponse, () => [["Logs", list_type(DailyLogResponse_$reflection())], ["HasMore", bool_type]]);
}

/**
 * A daily log as the host sees it: moderator-hidden entries are included and flagged.
 */
export class HostDailyLog extends Record {
    constructor(Log, IsHidden) {
        super();
        this.Log = Log;
        this.IsHidden = IsHidden;
    }
}

export function HostDailyLog_$reflection() {
    return record_type("Shared.HostDailyLog", [], HostDailyLog, () => [["Log", DailyLogResponse_$reflection()], ["IsHidden", bool_type]]);
}

export class GetHostDailyLogsResponse extends Record {
    constructor(Logs, HasMore, LoggedDays) {
        super();
        this.Logs = Logs;
        this.HasMore = HasMore;
        this.LoggedDays = LoggedDays;
    }
}

export function GetHostDailyLogsResponse_$reflection() {
    return record_type("Shared.GetHostDailyLogsResponse", [], GetHostDailyLogsResponse, () => [["Logs", list_type(HostDailyLog_$reflection())], ["HasMore", bool_type], ["LoggedDays", list_type(LoggedDay_$reflection())]]);
}

/**
 * How a daily log update treats the entry's photo. The client never holds the stored S3 key of an
 * existing photo (only a derived thumbnail URL), so "leave it alone" must be explicit.
 */
export class DailyLogPhotoChange extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["KeepPhoto", "SetPhoto", "RemovePhoto"];
    }
}

export function DailyLogPhotoChange_$reflection() {
    return union_type("Shared.DailyLogPhotoChange", [], DailyLogPhotoChange, () => [[], [["photoKey", string_type]], []]);
}

/**
 * How a daily log update treats the entry's units. Decimals do not survive the binary RPC round-trip
 * exactly (7.2 can return as 7.199999809265137), so a locked-units edit must say "keep what is stored"
 * instead of echoing the value the client holds.
 */
export class DailyLogUnitsChange extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["KeepUnits", "SetUnits"];
    }
}

export function DailyLogUnitsChange_$reflection() {
    return union_type("Shared.DailyLogUnitsChange", [], DailyLogUnitsChange, () => [[], [["Item", decimal_type]]]);
}

export class UpdateDailyLogRequest extends Record {
    constructor(ChallengeId, Date$, Units, Title, Note, Photo) {
        super();
        this.ChallengeId = ChallengeId;
        this.Date = Date$;
        this.Units = Units;
        this.Title = Title;
        this.Note = Note;
        this.Photo = Photo;
    }
}

export function UpdateDailyLogRequest_$reflection() {
    return record_type("Shared.UpdateDailyLogRequest", [], UpdateDailyLogRequest, () => [["ChallengeId", class_type("System.Guid")], ["Date", class_type("System.DateOnly")], ["Units", DailyLogUnitsChange_$reflection()], ["Title", string_type], ["Note", option_type(string_type)], ["Photo", DailyLogPhotoChange_$reflection()]]);
}

export class UnloggedChallengeContext extends Record {
    constructor(ChallengeId, Title, UnitType, CurrentTotal, TargetAmount, StartDate, Today, MissedDayCount) {
        super();
        this.ChallengeId = ChallengeId;
        this.Title = Title;
        this.UnitType = UnitType;
        this.CurrentTotal = CurrentTotal;
        this.TargetAmount = TargetAmount;
        this.StartDate = StartDate;
        this.Today = Today;
        this.MissedDayCount = (MissedDayCount | 0);
    }
}

export function UnloggedChallengeContext_$reflection() {
    return record_type("Shared.UnloggedChallengeContext", [], UnloggedChallengeContext, () => [["ChallengeId", class_type("System.Guid")], ["Title", string_type], ["UnitType", string_type], ["CurrentTotal", decimal_type], ["TargetAmount", decimal_type], ["StartDate", class_type("System.DateTimeOffset")], ["Today", class_type("System.DateOnly")], ["MissedDayCount", int32_type]]);
}

export class RenameChallengeRequest extends Record {
    constructor(ChallengeId, Title) {
        super();
        this.ChallengeId = ChallengeId;
        this.Title = Title;
    }
}

export function RenameChallengeRequest_$reflection() {
    return record_type("Shared.RenameChallengeRequest", [], RenameChallengeRequest, () => [["ChallengeId", class_type("System.Guid")], ["Title", string_type]]);
}

export class UpdateDescriptionRequest extends Record {
    constructor(ChallengeId, Description) {
        super();
        this.ChallengeId = ChallengeId;
        this.Description = Description;
    }
}

export function UpdateDescriptionRequest_$reflection() {
    return record_type("Shared.UpdateDescriptionRequest", [], UpdateDescriptionRequest, () => [["ChallengeId", class_type("System.Guid")], ["Description", option_type(string_type)]]);
}

export class ChangeThemeRequest extends Record {
    constructor(ChallengeId, Theme) {
        super();
        this.ChallengeId = ChallengeId;
        this.Theme = Theme;
    }
}

export function ChangeThemeRequest_$reflection() {
    return record_type("Shared.ChangeThemeRequest", [], ChangeThemeRequest, () => [["ChallengeId", class_type("System.Guid")], ["Theme", string_type]]);
}

export class ChangeUnitRequest extends Record {
    constructor(ChallengeId, Unit) {
        super();
        this.ChallengeId = ChallengeId;
        this.Unit = Unit;
    }
}

export function ChangeUnitRequest_$reflection() {
    return record_type("Shared.ChangeUnitRequest", [], ChangeUnitRequest, () => [["ChallengeId", class_type("System.Guid")], ["Unit", string_type]]);
}

export class ChangeDurationRequest extends Record {
    constructor(ChallengeId, Duration) {
        super();
        this.ChallengeId = ChallengeId;
        this.Duration = (Duration | 0);
    }
}

export function ChangeDurationRequest_$reflection() {
    return record_type("Shared.ChangeDurationRequest", [], ChangeDurationRequest, () => [["ChallengeId", class_type("System.Guid")], ["Duration", int32_type]]);
}

export class ChangeTargetAmountRequest extends Record {
    constructor(ChallengeId, TargetAmount) {
        super();
        this.ChallengeId = ChallengeId;
        this.TargetAmount = TargetAmount;
    }
}

export function ChangeTargetAmountRequest_$reflection() {
    return record_type("Shared.ChangeTargetAmountRequest", [], ChangeTargetAmountRequest, () => [["ChallengeId", class_type("System.Guid")], ["TargetAmount", decimal_type]]);
}

export class ChangeCharityRequest extends Record {
    constructor(ChallengeId, Charity) {
        super();
        this.ChallengeId = ChallengeId;
        this.Charity = Charity;
    }
}

export function ChangeCharityRequest_$reflection() {
    return record_type("Shared.ChangeCharityRequest", [], ChangeCharityRequest, () => [["ChallengeId", class_type("System.Guid")], ["Charity", CharityInfo_$reflection()]]);
}

export class RescheduleChallengeRequest extends Record {
    constructor(ChallengeId, StartDate, Timezone) {
        super();
        this.ChallengeId = ChallengeId;
        this.StartDate = StartDate;
        this.Timezone = Timezone;
    }
}

export function RescheduleChallengeRequest_$reflection() {
    return record_type("Shared.RescheduleChallengeRequest", [], RescheduleChallengeRequest, () => [["ChallengeId", class_type("System.Guid")], ["StartDate", class_type("System.DateTime")], ["Timezone", string_type]]);
}

export class ChangeReminderTimeRequest extends Record {
    constructor(ChallengeId, ReminderTimeOfDay) {
        super();
        this.ChallengeId = ChallengeId;
        this.ReminderTimeOfDay = ReminderTimeOfDay;
    }
}

export function ChangeReminderTimeRequest_$reflection() {
    return record_type("Shared.ChangeReminderTimeRequest", [], ChangeReminderTimeRequest, () => [["ChallengeId", class_type("System.Guid")], ["ReminderTimeOfDay", option_type(TimeOfDay_$reflection())]]);
}

export class AbandonChallengeRequest extends Record {
    constructor(ChallengeId, Reason) {
        super();
        this.ChallengeId = ChallengeId;
        this.Reason = Reason;
    }
}

export function AbandonChallengeRequest_$reflection() {
    return record_type("Shared.AbandonChallengeRequest", [], AbandonChallengeRequest, () => [["ChallengeId", class_type("System.Guid")], ["Reason", option_type(string_type)]]);
}

export class FeePaymentResult extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["PaymentRequired", "FeeBypassed"];
    }
}

export function FeePaymentResult_$reflection() {
    return union_type("Shared.FeePaymentResult", [], FeePaymentResult, () => [[["clientSecret", string_type]], []]);
}

export class VerifyPaymentRequest extends Record {
    constructor(ChallengeId, SessionId) {
        super();
        this.ChallengeId = ChallengeId;
        this.SessionId = SessionId;
    }
}

export function VerifyPaymentRequest_$reflection() {
    return record_type("Shared.VerifyPaymentRequest", [], VerifyPaymentRequest, () => [["ChallengeId", class_type("System.Guid")], ["SessionId", string_type]]);
}

/**
 * Nested challenge context returned with full pledge response (getPledge)
 */
export class PledgeChallengeContext extends Record {
    constructor(ChallengeId, Title, Description, CharityName, CharitySlug, HostName, UnitName, GoalUnits, StartDate, EndDate, Timezone, UnitsCompleted, PledgeCount, TotalPledged, ChallengeStatus) {
        super();
        this.ChallengeId = ChallengeId;
        this.Title = Title;
        this.Description = Description;
        this.CharityName = CharityName;
        this.CharitySlug = CharitySlug;
        this.HostName = HostName;
        this.UnitName = UnitName;
        this.GoalUnits = GoalUnits;
        this.StartDate = StartDate;
        this.EndDate = EndDate;
        this.Timezone = Timezone;
        this.UnitsCompleted = UnitsCompleted;
        this.PledgeCount = (PledgeCount | 0);
        this.TotalPledged = TotalPledged;
        this.ChallengeStatus = ChallengeStatus;
    }
}

export function PledgeChallengeContext_$reflection() {
    return record_type("Shared.PledgeChallengeContext", [], PledgeChallengeContext, () => [["ChallengeId", class_type("System.Guid")], ["Title", string_type], ["Description", option_type(string_type)], ["CharityName", string_type], ["CharitySlug", option_type(string_type)], ["HostName", string_type], ["UnitName", string_type], ["GoalUnits", decimal_type], ["StartDate", class_type("System.DateTimeOffset")], ["EndDate", class_type("System.DateTimeOffset")], ["Timezone", string_type], ["UnitsCompleted", decimal_type], ["PledgeCount", int32_type], ["TotalPledged", decimal_type], ["ChallengeStatus", string_type]]);
}

/**
 * Full pledge response (for getPledge) — pledge fields + challenge context
 */
export class PledgeResponse extends Record {
    constructor(PledgeId, AmountPerUnit, CapAtGoal, GoalUnitsAtPledge, CreatedAt, Status, CancelledAt, CancelReason, PledgedAmount, DonateLink, AbandonedAt, AbandonReason, Challenge) {
        super();
        this.PledgeId = PledgeId;
        this.AmountPerUnit = AmountPerUnit;
        this.CapAtGoal = CapAtGoal;
        this.GoalUnitsAtPledge = GoalUnitsAtPledge;
        this.CreatedAt = CreatedAt;
        this.Status = Status;
        this.CancelledAt = CancelledAt;
        this.CancelReason = CancelReason;
        this.PledgedAmount = PledgedAmount;
        this.DonateLink = DonateLink;
        this.AbandonedAt = AbandonedAt;
        this.AbandonReason = AbandonReason;
        this.Challenge = Challenge;
    }
}

export function PledgeResponse_$reflection() {
    return record_type("Shared.PledgeResponse", [], PledgeResponse, () => [["PledgeId", class_type("System.Guid")], ["AmountPerUnit", decimal_type], ["CapAtGoal", bool_type], ["GoalUnitsAtPledge", decimal_type], ["CreatedAt", class_type("System.DateTimeOffset")], ["Status", string_type], ["CancelledAt", option_type(class_type("System.DateTimeOffset"))], ["CancelReason", option_type(string_type)], ["PledgedAmount", option_type(decimal_type)], ["DonateLink", option_type(string_type)], ["AbandonedAt", option_type(class_type("System.DateTimeOffset"))], ["AbandonReason", option_type(string_type)], ["Challenge", PledgeChallengeContext_$reflection()]]);
}

/**
 * Lighter challenge context for list items (getPledgesByUser)
 */
export class PledgeSummaryChallenge extends Record {
    constructor(ChallengeId, Title, CharityName, CharitySlug, HostName, UnitName, GoalUnits, StartDate, EndDate, Timezone, UnitsCompleted, ChallengeStatus) {
        super();
        this.ChallengeId = ChallengeId;
        this.Title = Title;
        this.CharityName = CharityName;
        this.CharitySlug = CharitySlug;
        this.HostName = HostName;
        this.UnitName = UnitName;
        this.GoalUnits = GoalUnits;
        this.StartDate = StartDate;
        this.EndDate = EndDate;
        this.Timezone = Timezone;
        this.UnitsCompleted = UnitsCompleted;
        this.ChallengeStatus = ChallengeStatus;
    }
}

export function PledgeSummaryChallenge_$reflection() {
    return record_type("Shared.PledgeSummaryChallenge", [], PledgeSummaryChallenge, () => [["ChallengeId", class_type("System.Guid")], ["Title", string_type], ["CharityName", string_type], ["CharitySlug", option_type(string_type)], ["HostName", string_type], ["UnitName", string_type], ["GoalUnits", decimal_type], ["StartDate", class_type("System.DateTimeOffset")], ["EndDate", class_type("System.DateTimeOffset")], ["Timezone", string_type], ["UnitsCompleted", decimal_type], ["ChallengeStatus", string_type]]);
}

/**
 * Pledge summary for list endpoints (getPledgesByUser)
 */
export class PledgeSummaryResponse extends Record {
    constructor(PledgeId, AmountPerUnit, CapAtGoal, GoalUnitsAtPledge, CreatedAt, Status, CancelledAt, PledgedAmount, AbandonedAt, DonateLink, Challenge) {
        super();
        this.PledgeId = PledgeId;
        this.AmountPerUnit = AmountPerUnit;
        this.CapAtGoal = CapAtGoal;
        this.GoalUnitsAtPledge = GoalUnitsAtPledge;
        this.CreatedAt = CreatedAt;
        this.Status = Status;
        this.CancelledAt = CancelledAt;
        this.PledgedAmount = PledgedAmount;
        this.AbandonedAt = AbandonedAt;
        this.DonateLink = DonateLink;
        this.Challenge = Challenge;
    }
}

export function PledgeSummaryResponse_$reflection() {
    return record_type("Shared.PledgeSummaryResponse", [], PledgeSummaryResponse, () => [["PledgeId", class_type("System.Guid")], ["AmountPerUnit", decimal_type], ["CapAtGoal", bool_type], ["GoalUnitsAtPledge", decimal_type], ["CreatedAt", class_type("System.DateTimeOffset")], ["Status", string_type], ["CancelledAt", option_type(class_type("System.DateTimeOffset"))], ["PledgedAmount", option_type(decimal_type)], ["AbandonedAt", option_type(class_type("System.DateTimeOffset"))], ["DonateLink", option_type(string_type)], ["Challenge", PledgeSummaryChallenge_$reflection()]]);
}

/**
 * Convert to a PledgeResponse for optimistic display after creation.
 * Fields not available in the summary are set to sensible defaults.
 */
export function PledgeSummaryResponse__toPledgeResponse(this$) {
    return new PledgeResponse(this$.PledgeId, this$.AmountPerUnit, this$.CapAtGoal, this$.GoalUnitsAtPledge, this$.CreatedAt, this$.Status, this$.CancelledAt, undefined, this$.PledgedAmount, this$.DonateLink, this$.AbandonedAt, undefined, new PledgeChallengeContext(this$.Challenge.ChallengeId, this$.Challenge.Title, undefined, this$.Challenge.CharityName, this$.Challenge.CharitySlug, this$.Challenge.HostName, this$.Challenge.UnitName, this$.Challenge.GoalUnits, this$.Challenge.StartDate, this$.Challenge.EndDate, this$.Challenge.Timezone, this$.Challenge.UnitsCompleted, 0, fromParts(0, 0, 0, false, 0), this$.Challenge.ChallengeStatus));
}

export class MakePledgeRequest extends Record {
    constructor(ChallengeId, AmountPerUnit, CapAtGoal) {
        super();
        this.ChallengeId = ChallengeId;
        this.AmountPerUnit = AmountPerUnit;
        this.CapAtGoal = CapAtGoal;
    }
}

export function MakePledgeRequest_$reflection() {
    return record_type("Shared.MakePledgeRequest", [], MakePledgeRequest, () => [["ChallengeId", class_type("System.Guid")], ["AmountPerUnit", decimal_type], ["CapAtGoal", bool_type]]);
}

export class UpdatePledgeRequest extends Record {
    constructor(PledgeId, AmountPerUnit, CapAtGoal) {
        super();
        this.PledgeId = PledgeId;
        this.AmountPerUnit = AmountPerUnit;
        this.CapAtGoal = CapAtGoal;
    }
}

export function UpdatePledgeRequest_$reflection() {
    return record_type("Shared.UpdatePledgeRequest", [], UpdatePledgeRequest, () => [["PledgeId", class_type("System.Guid")], ["AmountPerUnit", decimal_type], ["CapAtGoal", bool_type]]);
}

export class CancelPledgeRequest extends Record {
    constructor(PledgeId, Reason) {
        super();
        this.PledgeId = PledgeId;
        this.Reason = Reason;
    }
}

export function CancelPledgeRequest_$reflection() {
    return record_type("Shared.CancelPledgeRequest", [], CancelPledgeRequest, () => [["PledgeId", class_type("System.Guid")], ["Reason", option_type(string_type)]]);
}

/**
 * Host-facing pledge item in getPledgesByChallenge
 */
export class ChallengePledgeItem extends Record {
    constructor(PledgeId, SupporterName, AmountPerUnit, CapAtGoal, CreatedAt, Status, CancelledAt, DonationEstimate, EstimateLabel) {
        super();
        this.PledgeId = PledgeId;
        this.SupporterName = SupporterName;
        this.AmountPerUnit = AmountPerUnit;
        this.CapAtGoal = CapAtGoal;
        this.CreatedAt = CreatedAt;
        this.Status = Status;
        this.CancelledAt = CancelledAt;
        this.DonationEstimate = DonationEstimate;
        this.EstimateLabel = EstimateLabel;
    }
}

export function ChallengePledgeItem_$reflection() {
    return record_type("Shared.ChallengePledgeItem", [], ChallengePledgeItem, () => [["PledgeId", class_type("System.Guid")], ["SupporterName", string_type], ["AmountPerUnit", decimal_type], ["CapAtGoal", bool_type], ["CreatedAt", class_type("System.DateTimeOffset")], ["Status", string_type], ["CancelledAt", option_type(class_type("System.DateTimeOffset"))], ["DonationEstimate", decimal_type], ["EstimateLabel", string_type]]);
}

export class GetPledgesByChallengeRequest extends Record {
    constructor(ChallengeId, Page, PageSize, IncludeAbandoned) {
        super();
        this.ChallengeId = ChallengeId;
        this.Page = (Page | 0);
        this.PageSize = (PageSize | 0);
        this.IncludeAbandoned = IncludeAbandoned;
    }
}

export function GetPledgesByChallengeRequest_$reflection() {
    return record_type("Shared.GetPledgesByChallengeRequest", [], GetPledgesByChallengeRequest, () => [["ChallengeId", class_type("System.Guid")], ["Page", int32_type], ["PageSize", int32_type], ["IncludeAbandoned", bool_type]]);
}

export class PledgesByChallengeResponse extends Record {
    constructor(Items, Page, PageSize, TotalItems, TotalPages, ActivePledgeCount, ActiveTotalPledged) {
        super();
        this.Items = Items;
        this.Page = (Page | 0);
        this.PageSize = (PageSize | 0);
        this.TotalItems = (TotalItems | 0);
        this.TotalPages = (TotalPages | 0);
        this.ActivePledgeCount = (ActivePledgeCount | 0);
        this.ActiveTotalPledged = ActiveTotalPledged;
    }
}

export function PledgesByChallengeResponse_$reflection() {
    return record_type("Shared.PledgesByChallengeResponse", [], PledgesByChallengeResponse, () => [["Items", list_type(ChallengePledgeItem_$reflection())], ["Page", int32_type], ["PageSize", int32_type], ["TotalItems", int32_type], ["TotalPages", int32_type], ["ActivePledgeCount", int32_type], ["ActiveTotalPledged", decimal_type]]);
}

export class BulkUpdateTimesRequest extends Record {
    constructor(ChallengeTimeOfDay, ReminderTimeOfDay) {
        super();
        this.ChallengeTimeOfDay = ChallengeTimeOfDay;
        this.ReminderTimeOfDay = ReminderTimeOfDay;
    }
}

export function BulkUpdateTimesRequest_$reflection() {
    return record_type("Shared.BulkUpdateTimesRequest", [], BulkUpdateTimesRequest, () => [["ChallengeTimeOfDay", option_type(string_type)], ["ReminderTimeOfDay", option_type(string_type)]]);
}

export class BulkUpdateTimesResponse extends Record {
    constructor(UpdatedCount) {
        super();
        this.UpdatedCount = (UpdatedCount | 0);
    }
}

export function BulkUpdateTimesResponse_$reflection() {
    return record_type("Shared.BulkUpdateTimesResponse", [], BulkUpdateTimesResponse, () => [["UpdatedCount", int32_type]]);
}

export class FeeShareScheduleTranche extends Record {
    constructor(Condition, Percentage, Amount) {
        super();
        this.Condition = Condition;
        this.Percentage = Percentage;
        this.Amount = Amount;
    }
}

export function FeeShareScheduleTranche_$reflection() {
    return record_type("Shared.FeeShareScheduleTranche", [], FeeShareScheduleTranche, () => [["Condition", string_type], ["Percentage", decimal_type], ["Amount", decimal_type]]);
}

export class FeeShareScheduleResponse extends Record {
    constructor(ScheduleId, Tranches, TotalPotential, FeeAmount, IsSnapshot) {
        super();
        this.ScheduleId = ScheduleId;
        this.Tranches = Tranches;
        this.TotalPotential = TotalPotential;
        this.FeeAmount = FeeAmount;
        this.IsSnapshot = IsSnapshot;
    }
}

export function FeeShareScheduleResponse_$reflection() {
    return record_type("Shared.FeeShareScheduleResponse", [], FeeShareScheduleResponse, () => [["ScheduleId", string_type], ["Tranches", list_type(FeeShareScheduleTranche_$reflection())], ["TotalPotential", decimal_type], ["FeeAmount", decimal_type], ["IsSnapshot", bool_type]]);
}

/**
 * One tranche of the challenge's fee-share schedule, with its current status.
 * Amounts are dollars; the cents->dollars conversion is done by the server API mapping.
 */
export class FeeShareTrancheStatus extends Record {
    constructor(Condition, Percentage, Amount, Satisfied) {
        super();
        this.Condition = Condition;
        this.Percentage = Percentage;
        this.Amount = Amount;
        this.Satisfied = Satisfied;
    }
}

export function FeeShareTrancheStatus_$reflection() {
    return record_type("Shared.FeeShareTrancheStatus", [], FeeShareTrancheStatus, () => [["Condition", string_type], ["Percentage", decimal_type], ["Amount", decimal_type], ["Satisfied", bool_type]]);
}

/**
 * Host-facing fee-share status for one challenge.
 */
export class FeeShareStatusResponse extends Record {
    constructor(Phase, ScheduleId, Tranches, TotalPotential, TotalAccrued) {
        super();
        this.Phase = Phase;
        this.ScheduleId = ScheduleId;
        this.Tranches = Tranches;
        this.TotalPotential = TotalPotential;
        this.TotalAccrued = TotalAccrued;
    }
}

export function FeeShareStatusResponse_$reflection() {
    return record_type("Shared.FeeShareStatusResponse", [], FeeShareStatusResponse, () => [["Phase", string_type], ["ScheduleId", string_type], ["Tranches", list_type(FeeShareTrancheStatus_$reflection())], ["TotalPotential", decimal_type], ["TotalAccrued", decimal_type]]);
}

export class IChallengeApi extends Record {
    constructor(createChallenge, getChallenges, getChallenge, addDailyLog, getDailyLogs, getHostDailyLogs, updateDailyLog, getUnloggedActiveChallenges, renameChallenge, setCoverImage, removeCoverImage, updateDescription, changeTheme, changeUnit, changeDuration, changeTargetAmount, changeCharity, rescheduleChallenge, changeReminderTime, publishChallenge, abandonChallenge, createCheckoutSession, verifyPayment, getPublicChallenge, getPublicChallenges, getIncompleteHostedChallengeCount, bulkUpdateTimes, getPublicDailyLogs, getFeeShareSchedule, getFeeShareStatus) {
        super();
        this.createChallenge = createChallenge;
        this.getChallenges = getChallenges;
        this.getChallenge = getChallenge;
        this.addDailyLog = addDailyLog;
        this.getDailyLogs = getDailyLogs;
        this.getHostDailyLogs = getHostDailyLogs;
        this.updateDailyLog = updateDailyLog;
        this.getUnloggedActiveChallenges = getUnloggedActiveChallenges;
        this.renameChallenge = renameChallenge;
        this.setCoverImage = setCoverImage;
        this.removeCoverImage = removeCoverImage;
        this.updateDescription = updateDescription;
        this.changeTheme = changeTheme;
        this.changeUnit = changeUnit;
        this.changeDuration = changeDuration;
        this.changeTargetAmount = changeTargetAmount;
        this.changeCharity = changeCharity;
        this.rescheduleChallenge = rescheduleChallenge;
        this.changeReminderTime = changeReminderTime;
        this.publishChallenge = publishChallenge;
        this.abandonChallenge = abandonChallenge;
        this.createCheckoutSession = createCheckoutSession;
        this.verifyPayment = verifyPayment;
        this.getPublicChallenge = getPublicChallenge;
        this.getPublicChallenges = getPublicChallenges;
        this.getIncompleteHostedChallengeCount = getIncompleteHostedChallengeCount;
        this.bulkUpdateTimes = bulkUpdateTimes;
        this.getPublicDailyLogs = getPublicDailyLogs;
        this.getFeeShareSchedule = getFeeShareSchedule;
        this.getFeeShareStatus = getFeeShareStatus;
    }
}

export function IChallengeApi_$reflection() {
    return record_type("Shared.IChallengeApi", [], IChallengeApi, () => [["createChallenge", lambda_type(CreateChallengeRequest_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [ChallengeResponse_$reflection(), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", ChallengeResponse_$reflection()]], [["ErrorValue", ApiError_$reflection()]]])]))], ["getChallenges", lambda_type(list_type(string_type), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(ChallengeResponse_$reflection()), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", list_type(ChallengeResponse_$reflection())]], [["ErrorValue", ApiError_$reflection()]]])]))], ["getChallenge", lambda_type(class_type("System.Guid"), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [ChallengeResponse_$reflection(), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", ChallengeResponse_$reflection()]], [["ErrorValue", ApiError_$reflection()]]])]))], ["addDailyLog", lambda_type(AddDailyLogRequest_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [DailyLogResponse_$reflection(), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", DailyLogResponse_$reflection()]], [["ErrorValue", ApiError_$reflection()]]])]))], ["getDailyLogs", lambda_type(GetDailyLogsRequest_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [GetDailyLogsResponse_$reflection(), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", GetDailyLogsResponse_$reflection()]], [["ErrorValue", ApiError_$reflection()]]])]))], ["getHostDailyLogs", lambda_type(GetDailyLogsRequest_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [GetHostDailyLogsResponse_$reflection(), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", GetHostDailyLogsResponse_$reflection()]], [["ErrorValue", ApiError_$reflection()]]])]))], ["updateDailyLog", lambda_type(UpdateDailyLogRequest_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [DailyLogResponse_$reflection(), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", DailyLogResponse_$reflection()]], [["ErrorValue", ApiError_$reflection()]]])]))], ["getUnloggedActiveChallenges", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(UnloggedChallengeContext_$reflection()), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", list_type(UnloggedChallengeContext_$reflection())]], [["ErrorValue", ApiError_$reflection()]]])]))], ["renameChallenge", lambda_type(RenameChallengeRequest_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", ApiError_$reflection()]]])]))], ["setCoverImage", lambda_type(SetCoverImageRequest_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [ChallengeCoverImage_$reflection(), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", ChallengeCoverImage_$reflection()]], [["ErrorValue", ApiError_$reflection()]]])]))], ["removeCoverImage", lambda_type(class_type("System.Guid"), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", ApiError_$reflection()]]])]))], ["updateDescription", lambda_type(UpdateDescriptionRequest_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", ApiError_$reflection()]]])]))], ["changeTheme", lambda_type(ChangeThemeRequest_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", ApiError_$reflection()]]])]))], ["changeUnit", lambda_type(ChangeUnitRequest_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", ApiError_$reflection()]]])]))], ["changeDuration", lambda_type(ChangeDurationRequest_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", ApiError_$reflection()]]])]))], ["changeTargetAmount", lambda_type(ChangeTargetAmountRequest_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", ApiError_$reflection()]]])]))], ["changeCharity", lambda_type(ChangeCharityRequest_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", ApiError_$reflection()]]])]))], ["rescheduleChallenge", lambda_type(RescheduleChallengeRequest_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", ApiError_$reflection()]]])]))], ["changeReminderTime", lambda_type(ChangeReminderTimeRequest_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", ApiError_$reflection()]]])]))], ["publishChallenge", lambda_type(class_type("System.Guid"), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", ApiError_$reflection()]]])]))], ["abandonChallenge", lambda_type(AbandonChallengeRequest_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", ApiError_$reflection()]]])]))], ["createCheckoutSession", lambda_type(class_type("System.Guid"), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [FeePaymentResult_$reflection(), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", FeePaymentResult_$reflection()]], [["ErrorValue", ApiError_$reflection()]]])]))], ["verifyPayment", lambda_type(VerifyPaymentRequest_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", ApiError_$reflection()]]])]))], ["getPublicChallenge", lambda_type(class_type("System.Guid"), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [ChallengeResponse_$reflection(), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", ChallengeResponse_$reflection()]], [["ErrorValue", ApiError_$reflection()]]])]))], ["getPublicChallenges", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(ChallengeResponse_$reflection()), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", list_type(ChallengeResponse_$reflection())]], [["ErrorValue", ApiError_$reflection()]]])]))], ["getIncompleteHostedChallengeCount", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [int32_type, ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", int32_type]], [["ErrorValue", ApiError_$reflection()]]])]))], ["bulkUpdateTimes", lambda_type(BulkUpdateTimesRequest_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [BulkUpdateTimesResponse_$reflection(), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", BulkUpdateTimesResponse_$reflection()]], [["ErrorValue", ApiError_$reflection()]]])]))], ["getPublicDailyLogs", lambda_type(class_type("System.Guid"), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(DailyLogResponse_$reflection()), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", list_type(DailyLogResponse_$reflection())]], [["ErrorValue", ApiError_$reflection()]]])]))], ["getFeeShareSchedule", lambda_type(option_type(class_type("System.Guid")), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [FeeShareScheduleResponse_$reflection(), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", FeeShareScheduleResponse_$reflection()]], [["ErrorValue", ApiError_$reflection()]]])]))], ["getFeeShareStatus", lambda_type(class_type("System.Guid"), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [option_type(FeeShareStatusResponse_$reflection()), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", option_type(FeeShareStatusResponse_$reflection())]], [["ErrorValue", ApiError_$reflection()]]])]))]]);
}

export class IModerationApi extends Record {
    constructor(getModerationStatus, hideChallenge, restoreChallenge, hideDailyLog, restoreDailyLog, hideCoverImage, restoreCoverImage, suspendAccount, reinstateAccount) {
        super();
        this.getModerationStatus = getModerationStatus;
        this.hideChallenge = hideChallenge;
        this.restoreChallenge = restoreChallenge;
        this.hideDailyLog = hideDailyLog;
        this.restoreDailyLog = restoreDailyLog;
        this.hideCoverImage = hideCoverImage;
        this.restoreCoverImage = restoreCoverImage;
        this.suspendAccount = suspendAccount;
        this.reinstateAccount = reinstateAccount;
    }
}

export function IModerationApi_$reflection() {
    return record_type("Shared.IModerationApi", [], IModerationApi, () => [["getModerationStatus", lambda_type(class_type("System.Guid"), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [ModerationStatusResponse_$reflection(), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", ModerationStatusResponse_$reflection()]], [["ErrorValue", ApiError_$reflection()]]])]))], ["hideChallenge", lambda_type(HideChallengeRequest_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", ApiError_$reflection()]]])]))], ["restoreChallenge", lambda_type(class_type("System.Guid"), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", ApiError_$reflection()]]])]))], ["hideDailyLog", lambda_type(HideDailyLogRequest_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", ApiError_$reflection()]]])]))], ["restoreDailyLog", lambda_type(RestoreDailyLogRequest_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", ApiError_$reflection()]]])]))], ["hideCoverImage", lambda_type(HideCoverImageRequest_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", ApiError_$reflection()]]])]))], ["restoreCoverImage", lambda_type(class_type("System.Guid"), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", ApiError_$reflection()]]])]))], ["suspendAccount", lambda_type(SuspendAccountRequest_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", ApiError_$reflection()]]])]))], ["reinstateAccount", lambda_type(class_type("System.Guid"), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", ApiError_$reflection()]]])]))]]);
}

export class IPledgeApi extends Record {
    constructor(makePledge, getPledge, getPledgesByUser, updatePledge, cancelPledge, getPledgesByChallenge, getUserPledgeForChallenge) {
        super();
        this.makePledge = makePledge;
        this.getPledge = getPledge;
        this.getPledgesByUser = getPledgesByUser;
        this.updatePledge = updatePledge;
        this.cancelPledge = cancelPledge;
        this.getPledgesByChallenge = getPledgesByChallenge;
        this.getUserPledgeForChallenge = getUserPledgeForChallenge;
    }
}

export function IPledgeApi_$reflection() {
    return record_type("Shared.IPledgeApi", [], IPledgeApi, () => [["makePledge", lambda_type(MakePledgeRequest_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [PledgeSummaryResponse_$reflection(), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", PledgeSummaryResponse_$reflection()]], [["ErrorValue", ApiError_$reflection()]]])]))], ["getPledge", lambda_type(class_type("System.Guid"), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [PledgeResponse_$reflection(), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", PledgeResponse_$reflection()]], [["ErrorValue", ApiError_$reflection()]]])]))], ["getPledgesByUser", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(PledgeSummaryResponse_$reflection()), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", list_type(PledgeSummaryResponse_$reflection())]], [["ErrorValue", ApiError_$reflection()]]])]))], ["updatePledge", lambda_type(UpdatePledgeRequest_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [PledgeResponse_$reflection(), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", PledgeResponse_$reflection()]], [["ErrorValue", ApiError_$reflection()]]])]))], ["cancelPledge", lambda_type(CancelPledgeRequest_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [PledgeResponse_$reflection(), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", PledgeResponse_$reflection()]], [["ErrorValue", ApiError_$reflection()]]])]))], ["getPledgesByChallenge", lambda_type(GetPledgesByChallengeRequest_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [PledgesByChallengeResponse_$reflection(), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", PledgesByChallengeResponse_$reflection()]], [["ErrorValue", ApiError_$reflection()]]])]))], ["getUserPledgeForChallenge", lambda_type(class_type("System.Guid"), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [option_type(PledgeSummaryResponse_$reflection()), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", option_type(PledgeSummaryResponse_$reflection())]], [["ErrorValue", ApiError_$reflection()]]])]))]]);
}

export class UserProfileResponse extends Record {
    constructor(UserId, ZitadelUserId, Email, FirstName, LastName, Bio, ProfilePhotoUrl, Timezone, PreferredChallengeTimeOfDay, PreferredReminderTimeOfDay) {
        super();
        this.UserId = UserId;
        this.ZitadelUserId = ZitadelUserId;
        this.Email = Email;
        this.FirstName = FirstName;
        this.LastName = LastName;
        this.Bio = Bio;
        this.ProfilePhotoUrl = ProfilePhotoUrl;
        this.Timezone = Timezone;
        this.PreferredChallengeTimeOfDay = PreferredChallengeTimeOfDay;
        this.PreferredReminderTimeOfDay = PreferredReminderTimeOfDay;
    }
}

export function UserProfileResponse_$reflection() {
    return record_type("Shared.UserProfileResponse", [], UserProfileResponse, () => [["UserId", string_type], ["ZitadelUserId", string_type], ["Email", option_type(string_type)], ["FirstName", option_type(string_type)], ["LastName", option_type(string_type)], ["Bio", option_type(string_type)], ["ProfilePhotoUrl", option_type(string_type)], ["Timezone", option_type(string_type)], ["PreferredChallengeTimeOfDay", option_type(string_type)], ["PreferredReminderTimeOfDay", option_type(string_type)]]);
}

export class CheckProfileCompleteResponse extends Record {
    constructor(ProfileComplete, UserId) {
        super();
        this.ProfileComplete = ProfileComplete;
        this.UserId = UserId;
    }
}

export function CheckProfileCompleteResponse_$reflection() {
    return record_type("Shared.CheckProfileCompleteResponse", [], CheckProfileCompleteResponse, () => [["ProfileComplete", bool_type], ["UserId", string_type]]);
}

export class UpdateProfileRequest extends Record {
    constructor(Bio, ProfilePhotoUrl, Timezone) {
        super();
        this.Bio = Bio;
        this.ProfilePhotoUrl = ProfilePhotoUrl;
        this.Timezone = Timezone;
    }
}

export function UpdateProfileRequest_$reflection() {
    return record_type("Shared.UpdateProfileRequest", [], UpdateProfileRequest, () => [["Bio", option_type(string_type)], ["ProfilePhotoUrl", option_type(string_type)], ["Timezone", option_type(string_type)]]);
}

export class UpdatePreferredTimesRequest extends Record {
    constructor(PreferredChallengeTimeOfDay, PreferredReminderTimeOfDay) {
        super();
        this.PreferredChallengeTimeOfDay = PreferredChallengeTimeOfDay;
        this.PreferredReminderTimeOfDay = PreferredReminderTimeOfDay;
    }
}

export function UpdatePreferredTimesRequest_$reflection() {
    return record_type("Shared.UpdatePreferredTimesRequest", [], UpdatePreferredTimesRequest, () => [["PreferredChallengeTimeOfDay", string_type], ["PreferredReminderTimeOfDay", string_type]]);
}

/**
 * One preference-controlled workflow's current email setting, as shown on the profile page.
 */
export class NotificationPreference extends Record {
    constructor(WorkflowId, Enabled) {
        super();
        this.WorkflowId = WorkflowId;
        this.Enabled = Enabled;
    }
}

export function NotificationPreference_$reflection() {
    return record_type("Shared.NotificationPreference", [], NotificationPreference, () => [["WorkflowId", string_type], ["Enabled", bool_type]]);
}

export class SetNotificationPreferenceRequest extends Record {
    constructor(WorkflowId, Enabled) {
        super();
        this.WorkflowId = WorkflowId;
        this.Enabled = Enabled;
    }
}

export function SetNotificationPreferenceRequest_$reflection() {
    return record_type("Shared.SetNotificationPreferenceRequest", [], SetNotificationPreferenceRequest, () => [["WorkflowId", string_type], ["Enabled", bool_type]]);
}

export class IUserApi extends Record {
    constructor(ensureRegistered, getProfile, checkProfileComplete, updateProfile, updatePreferredTimes, getNotificationPreferences, setNotificationPreference) {
        super();
        this.ensureRegistered = ensureRegistered;
        this.getProfile = getProfile;
        this.checkProfileComplete = checkProfileComplete;
        this.updateProfile = updateProfile;
        this.updatePreferredTimes = updatePreferredTimes;
        this.getNotificationPreferences = getNotificationPreferences;
        this.setNotificationPreference = setNotificationPreference;
    }
}

export function IUserApi_$reflection() {
    return record_type("Shared.IUserApi", [], IUserApi, () => [["ensureRegistered", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", ApiError_$reflection()]]])]))], ["getProfile", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [UserProfileResponse_$reflection(), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", UserProfileResponse_$reflection()]], [["ErrorValue", ApiError_$reflection()]]])]))], ["checkProfileComplete", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [CheckProfileCompleteResponse_$reflection(), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", CheckProfileCompleteResponse_$reflection()]], [["ErrorValue", ApiError_$reflection()]]])]))], ["updateProfile", lambda_type(UpdateProfileRequest_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", ApiError_$reflection()]]])]))], ["updatePreferredTimes", lambda_type(UpdatePreferredTimesRequest_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", ApiError_$reflection()]]])]))], ["getNotificationPreferences", lambda_type(unit_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(NotificationPreference_$reflection()), ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", list_type(NotificationPreference_$reflection())]], [["ErrorValue", ApiError_$reflection()]]])]))], ["setNotificationPreference", lambda_type(SetNotificationPreferenceRequest_$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, ApiError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", ApiError_$reflection()]]])]))]]);
}

//# sourceMappingURL=Shared.js.map
